import {DateTime} from 'luxon'

import {l} from './i18n'

export const isValidDateTime = (item: unknown): boolean => {
  return DateTime.fromISO(item as string, {zone: 'utc'}).isValid || DateTime.fromJSDate(item as Date).isValid
}

export const getDateRange = (
  firstDate: Date | string,
  secondDate: Date | string,
  format: 'days' | 'hours' | 'minutes' | 'months' | 'seconds' | 'weeks' | 'years' = 'days'
): number => {
  const start = typeof firstDate === 'string' ? DateTime.fromISO(firstDate, {zone: 'utc'}) : DateTime.fromJSDate(firstDate)
  const end = typeof secondDate === 'string' ? DateTime.fromISO(secondDate, {zone: 'utc'}) : DateTime.fromJSDate(secondDate)

  return end.diff(start, format).toObject()[format] || 0
}

export const addDateTime = (
  item: Date,
  interval = 0,
  type: 'days' | 'hours' | 'minutes' | 'months' | 'seconds' | 'weeks' | 'years' = 'hours'
): Date => {
  if (isValidDateTime(item)) {
    const dateTime = typeof item === 'string' ? DateTime.fromISO(item, {zone: 'utc'}) : DateTime.fromJSDate(item)
    return dateTime.plus({[type]: interval}).toJSDate()
  }
  return item
}

export const formatMinutes = (minutes: number) => {
  if (minutes % 60 === 0) {
    return l('hours_short', {
      value: minutes / 60
    })
  } else if (minutes < 60) {
    return l('minutes_short', {
      value: minutes
    })
  }
    return `${l('hours_short', {
      value: Math.floor(minutes / 60)
    })} ${l('minutes_short', {
      value: minutes % 60
    })}`
}

export const currDateWithTimeZone = (timeZone: string) => {
  return DateTime.now().setZone(timeZone).toMillis()
}
